import { Col, Flex, Row, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ImageCapturePageDetailCard } from "./components/ImageCapturePageDetailCard";
import {
  deleteImageCapturePageById,
  fetchImageCapturePageById,
} from "@/lib/api/resources/imageCapturePages";

export const ImageCapturePageDetail = () => {
  const navigate = useNavigate();
  const { id: imageCaptureId, pageId } = useParams();

  // Guard against missing params
  if (!imageCaptureId || !pageId) {
    message.error(
      "Ongeldige of ontbrekende parameters voor het weergeven van de pagina.",
    );
    return null;
  }

  const { data, isLoading } = useQuery({
    queryKey: ["imageCapturePage", pageId],
    queryFn: () => fetchImageCapturePageById(pageId as string),
  });

  const deleteMutation = useMutation({
    mutationFn: () => deleteImageCapturePageById(pageId as string),
    onSuccess: () => {
      if (imageCaptureId) {
        navigate(`/image-captures/${imageCaptureId}`);
      } else {
        navigate(`/image-captures`);
      }
      message.success("Afbeelding Capture pagina succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de Afbeelding Capture pagina",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Flex vertical gap={16}>
          <ImageCapturePageDetailCard
            deleteMutation={deleteMutation}
            page={data}
            isLoading={isLoading}
          />
        </Flex>
      </Col>
    </Row>
  );
};
